import { render, staticRenderFns } from "./capAccount.vue?vue&type=template&id=c18394b2&"
import script from "./capAccount.vue?vue&type=script&lang=js&"
export * from "./capAccount.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports